import './style.scss'
import clsx from 'clsx'

import TalentCardPaper from '../_Core/TalentCardPaper'
import { useContext } from 'use-context-selector'
import { TalentCardContext } from '../_Core/Context'
import TopSkills from '../../TopSkills25'
import { CLUB_SHORT } from '../../../lib/apollo/config'
import { useImageFieldNormalization } from '../../../hooks/useImageFieldNormalization'
import { canSelectTalentCardType } from '../../../lib/helpers/talentCardHelpers'

interface TalentCardMediumFrontProps {
  visible: boolean
  onFlipCardClick: () => void
}

const TalentCardMediumFront: React.FC<TalentCardMediumFrontProps> = ({ visible, onFlipCardClick }) => {
  const { certificate } = useContext(TalentCardContext)

  // Automatically normalize image fields if needed
  useImageFieldNormalization(certificate, {
    enabled: true,
    camp: certificate?.camp
  })

  if (!certificate) return null

  // Determine which image to use based on talentCardType
  const talentCardType = (certificate.camp as any)?.talentCardType
  const isOldCamp = !canSelectTalentCardType(certificate.camp?.end)

  // In preview mode (when image is a data URL), always use the image field
  const isPreview = certificate.image?.startsWith('data:')

  // Logic for image selection:
  // 1. Preview mode: always use the image field (it's the preview)
  // 2. Old camps (before Sept 2025): prefer imageWithBackground, fallback to image (both have background)
  // 3. New camps with "25_with_bg": use imageWithBackground
  // 4. New camps with "25" or empty: use processed image (freigestellt)
  const rawImageUrl = isPreview
    ? certificate.image
    : isOldCamp
      ? (certificate.imageWithBackground ?? certificate.image) // both have background for old camps
      : talentCardType === '25_with_bg'
        ? (certificate.imageWithBackground ?? certificate.image)
        : (certificate.image ?? certificate.imageWithBackground) // for new camps, image is freigestellt

  // Filter out default talent card image
  const imageUrl = rawImageUrl?.includes('default_talentcard.png') ? null : rawImageUrl

  return (
        <TalentCardPaper
            className={clsx('talentcard-medium-front talentcard-medium-front--talent', {
              'talentcard-medium-front--visible': visible,
              // Only apply freigestellt class for new camps with explicit "25" selection
              // Never apply it to old camps or when talentCardType is not set
              'talentcard-medium-front--freigestellt': !isOldCamp && talentCardType === '25',
              // Apply with-background class for old camps OR when explicitly selected
              'talentcard-medium-front--with-background': isOldCamp || talentCardType === '25_with_bg'
            })}
            onFlipCardClick={onFlipCardClick}
        >
                <div
                    className='display-flex-column ion-justify-content-center'
                    style={{ position: 'relative' }}
                >
                    {imageUrl && (
                        <img
                            className={clsx('talentcard-medium-front__avatar_image rbl-25', {
                              'negative-margin': CLUB_SHORT === 'rbl'
                            })}
                            alt='talent image here'
                            src={imageUrl}
                        />
                    )}
                </div>

            <TopSkills
                lastName={certificate.lastName}
                values={certificate.vote}
                talentClass={certificate.talentClass}
                withValues={CLUB_SHORT === 'rbl'}
            />
        </TalentCardPaper >
  )
}

export default TalentCardMediumFront
